<template lang="pug">
  v-container
    v-row
      v-col
        input-captcha(
          phone-number="+33655555555"
          v-model="captcha"
        )
</template>

<script>
import { page } from '@iez/core'
import firebase from '@firebase/app'
import { onMounted, ref } from '@vue/composition-api'
import InputCaptcha from '@iez/components/inputs/captcha/'
import waitFor from '@iez/lib/wait-for/'

const path = {
  name: `ModifyPhoneNumber`,
  path: `/modify-phone-number`
}

export default {
  ...path,

  components: {
    InputCaptcha
  },

  setup () {
    page.topBar.set({
      title: `Modification du numéro de tél`
    })

    const captcha = ref(null)

    console.log(firebase.auth())

    onMounted(async () => {
      var provider = new firebase.auth.PhoneAuthProvider();
      console.log('', captcha.value, 2)
      await waitFor({
        dependencies: () => captcha.value
      })
      provider.verifyPhoneNumber('+33655555555', captcha.value)
          .then(function(verificationId) {
            var verificationCode = window.prompt('Please enter the verification ' +
                'code that was sent to your mobile device.');
            return firebase.auth.PhoneAuthProvider.credential(verificationId,
                verificationCode);
          })
          .then(function(phoneCredential) {
            return firebase.auth().currentUser.updatePhoneNumber(phoneCredential);
          });
    })

    return {
      captcha
    }
  }
}
</script>
